import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role === "admin") nav("/admin");
      else nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || t.login.error);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-[#0D0D0D] px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-14">
          <Logo asLink={false} withText={false} size="w-24 h-24" />
        </Link>

        <div className="bg-[#1E1E1E] border border-white/10 rounded-md p-10">
          <h1 className="font-display text-3xl text-white mb-8">{t.login.title}</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-white/50 block mb-2">{t.login.email}</label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0D0D0D] border-white/10 text-white h-11" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-white/50 block mb-2">{t.login.password}</label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0D0D0D] border-white/10 text-white h-11" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-[#C8A75A] text-black hover:bg-white uppercase tracking-widest text-xs py-6 rounded-md mt-4">
              {busy ? "…" : t.login.submit}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
